export { default } from "ember-animated/services/-ea-motion";
